export const UPDATE='UPDATE';
export const DELETE='DELETE';
export const DELETE_IMAGE='DELETE_IMAGE';
export const FETCH_ALL='FETCH_ALL';
export const CREATE='CREATE';

export const START_LOADING='START_LOADING';
export const END_LOADING='END_LOADING';
